import { useTranslation } from "react-i18next";
import useNumberFormat from "../../../hooks/useNumberFormat";
import {
    formatDateToLocalDate,
    getInstalmentStatus,
} from "../../../utils/utils";
import styles from "./styles/GetTicketInfoWindowContent.module.css";

const GetTicketInfoWindowContent = ({ installment, currency }) => {
    const formatNum = useNumberFormat();
    const { t } = useTranslation();
    return (
        <div className={` v-flex-container`}>
            <div className={`${styles.header_container}  flex-container`}>
                <p className={` flex-container ${styles.header_content}`}>
                    <span className={`${styles.info_label} `}>
                        {t("instalment")}:
                    </span>
                    <span className={`${styles.info_content} `}>
                        {installment?.txt.split("#")[1]}
                    </span>
                </p>
                <p className={`flex-container ${styles.header_content}`}>
                    <span className={`${styles.info_label} `}>
                        {t("status")}:
                    </span>
                    <span className={`${styles.info_content} `}>
                        {t(getInstalmentStatus(installment?.status))}
                    </span>
                </p>
            </div>
            <div className={`${styles.body_container} flex-container`}>
                <p className={`flex-container ${styles.body_content}`}>
                    <span className={`${styles.info_label}`}>
                        {" "}
                        {t("date")}:
                    </span>
                    <span className={`${styles.info_content}`}>
                        {formatDateToLocalDate(installment?.dateAndTime)}
                    </span>
                </p>
                <p className={`flex-container ${styles.body_content}`}>
                    <span className={`${styles.info_label}`}>
                        {" "}
                        {t("amount")}:
                    </span>
                    <span className={`${styles.info_content}`}>
                        {currency} {formatNum(installment?.netAmount)}
                    </span>
                </p>
                <p className={`flex-container ${styles.body_content}`}>
                    <span className={`${styles.info_label}`}> {t("tax")}:</span>
                    <span className={`${styles.info_content}`}>
                        {currency}
                        {formatNum(installment?.taxAmount)}
                    </span>
                </p>
            </div>
        </div>
    );
};

export default GetTicketInfoWindowContent;
